
import React from "react";
import { createRoot } from "react-dom/client";
import SceneGenerator from "./scene-generator/SceneGenerator";
import { SceneGeneratorTheme } from "./scene-generator/types";

// Function to embed the scene generator in blog posts
export const embedSceneGenerator = (
  containerId: string,
  theme: SceneGeneratorTheme = "default",
  postId?: string
) => {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error(`Container with ID ${containerId} not found`);
    return;
  }

  // Create root for React component
  const root = createRoot(container);
  
  // Render scene generator in the container
  root.render(
    <SceneGenerator theme={theme} postId={postId} />
  );

  console.log(`Scene Generator embedded in ${containerId}`);
};

// Export a standalone component that can be rendered directly
const EmbeddableSceneGenerator: React.FC<{
  theme?: SceneGeneratorTheme;
  postId?: string;
}> = ({ theme = "default", postId }) => {
  return <SceneGenerator theme={theme} postId={postId} />;
};

export default EmbeddableSceneGenerator;
